

import React, { useState, useEffect } from 'react';
import {
    Modal,
    Box,
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    IconButton,
    Snackbar,
    Alert,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from 'auth/Auth';
import colors from "assets/theme/base/colors";

const NewTrainingModuleModal = ({
    isOpen,
    onClose,
    onSave,
}) => {
    const { axiosInstance } = useAuth();
    const [isSaving, setIsSaving] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        content_url: '',
        description: '',
        training_for: '',
        active: true
    });

    const [toast, setToast] = useState({ open: false, message: '', severity: 'info' });

    useEffect(() => {
        if (isOpen) {
            setFormData({
                name: '', content_url: '', description: '',
                training_for: '', active: true
            });
        }
    }, [isOpen]);

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            await onSave(formData);
            onClose();
        } catch (error) {
            console.error('Error saving Training Module:', error);
            setToast({
                open: true,
                message: error.response?.data?.detail || 'Error saving Training Module',
                severity: 'error'
            });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <>
            <Modal open={isOpen} onClose={onClose}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '95%', sm: '600px' },
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '90vh',
                    overflowY: 'auto'
                }}>
                    <Box className="pearl-popup-header" sx={{
                        backgroundColor: colors.popupHeader.background,
                        px: 3,
                        py: 2,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <MDTypography variant="h6" color="white">Add New Training Module</MDTypography>
                        <IconButton onClick={onClose} size="small" sx={{ color: 'white' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Box sx={{ p: 4 }}>
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Training Title"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                        variant="outlined"
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Content URL"
                                        name="content_url"
                                        value={formData.content_url}
                                        onChange={handleInputChange}
                                        required
                                        variant="outlined"
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth variant="outlined" margin="normal" required>
                                        <InputLabel>Intended For</InputLabel>
                                        <Select
                                            name="training_for"
                                            value={formData.training_for}
                                            onChange={handleInputChange}
                                            label="Intended For"

                                        >
                                            <MenuItem value="Guide">Guide</MenuItem>
                                            <MenuItem value="Supplier">Supplier</MenuItem>
                                            <MenuItem value="Both">Both</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="active"
                                                checked={formData.active}
                                                onChange={handleInputChange}
                                            />
                                        }
                                        label="Active"
                                        sx={{ mt: 2 }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Description"
                                        name="description"
                                        multiline
                                        rows={3}
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        variant="outlined"
                                        margin="normal"
                                    />
                                </Grid>
                            </Grid>

                            <MDBox mt={4} display="flex" justifyContent="flex-end">
                                <MDButton onClick={onClose} color="secondary" sx={{ mr: 2 }}>Cancel</MDButton>
                                <MDButton type="submit" variant="gradient" color="info" disabled={isSaving}>
                                    {isSaving ? <CircularProgress size={20} color="inherit" /> : 'Save Module'}
                                </MDButton>
                            </MDBox>
                        </form>
                    </Box>
                </Box>
            </Modal>

            <Snackbar
                open={toast.open}
                autoHideDuration={6000}
                onClose={() => setToast({ ...toast, open: false })}
            >
                <Alert severity={toast.severity} onClose={() => setToast({ ...toast, open: false })}>
                    {toast.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default NewTrainingModuleModal;
